import React from 'react';

export const OneFacebookIcon = ({
  className,
  fillColor = 'white',
  ...props
}) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      className={className}
    >
      <circle cx="27" cy="27" r="26.5" fill="currentColor" stroke="white" />
      <path
        d="M31.364 23.8285H28.5155V21.9603C28.5155 21.2587 28.9805 21.0951 29.308 21.0951C29.6348 21.0951 31.3182 21.0951 31.3182 21.0951V18.0108L28.5498 18C25.4766 18 24.7773 20.3004 24.7773 21.7725V23.8285H23V27.0067H24.7773C24.7773 31.0855 24.7773 36 24.7773 36H28.5155C28.5155 36 28.5155 31.0371 28.5155 27.0067H31.038L31.364 23.8285Z"
        fill={fillColor} // Use fillColor prop here
      />
    </svg>
  );
};
